import {RemoteFeedMappingRule} from '../locationFeed.types';
import {FeedRuleType} from '../locationFeed.enums';

function getFeedRuleType(rule: RemoteFeedMappingRule): FeedRuleType {
  if (rule?.capitalization) return FeedRuleType.Capitalize;
  if (rule?.replace) return FeedRuleType.Replace;
  if (rule?.regexReplace) return FeedRuleType.ReplaceRegex;
  if (rule?.defaultValue) return FeedRuleType.DefaultValue;
  if (rule?.overrideValue) return FeedRuleType.OverrideValue;
  if (rule?.regexExtract) return FeedRuleType.RegexExtract;
  if (rule?.removeBackground) return FeedRuleType.RemoveImagesBackground;

  return FeedRuleType.Replace;
}

export default getFeedRuleType;
